var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMenuMobile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 22,
    viewBox: "0 0 24 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.62967 21H22.3704C23.0834 21 23.6667 20.25 23.6667 19.3333C23.6667 18.4167 23.0834 17.6667 22.3704 17.6667H1.62967C0.916707 17.6667 0.333374 18.4167 0.333374 19.3333C0.333374 20.25 0.916707 21 1.62967 21ZM1.62967 12.6667H22.3704C23.0834 12.6667 23.6667 11.9167 23.6667 11C23.6667 10.0833 23.0834 9.33333 22.3704 9.33333H1.62967C0.916707 9.33333 0.333374 10.0833 0.333374 11C0.333374 11.9167 0.916707 12.6667 1.62967 12.6667ZM0.333374 2.66667C0.333374 3.58333 0.916707 4.33333 1.62967 4.33333H22.3704C23.0834 4.33333 23.6667 3.58333 23.6667 2.66667C23.6667 1.75 23.0834 1 22.3704 1H1.62967C0.916707 1 0.333374 1.75 0.333374 2.66667Z",
    fill: "white",
    stroke: "#353434",
    strokeWidth: 0.4
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuMobile);
export default __webpack_public_path__ + "static/media/menu-mobile.4e490a86416eaf04d79f2eb4710105b7.svg";
export { ForwardRef as ReactComponent };